import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'tiny',
  template: `<textarea id="{{elementId}}"></textarea>`
})
export class TinyComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() elementId: String;
  @Output() onEditorKeyup = new EventEmitter<any>();

  public editor;

  ngOnInit() {

  }

  ngAfterViewInit() {
    tinymce.init({
      baseURL: '/assets/tinymce/',
      selector: '#' + this.elementId,
      min_height: 500,
      plugins: ['link', 'paste', 'table', 'image', 'textcolor', 'code'],
      skin_url: '/assets/skins/lightgray',
      menubar: 'insert table',
      toolbar: 'undo redo | alignleft aligncenter alignright alignjustify | fontsizeselect bold italic forecolor backcolor | link image code',
      setup: editor => {
        this.editor = editor;
        editor.on('keyup', () => {
          const content = editor.getContent();
          this.onEditorKeyup.emit(content);
        });
      },
      init_instance_callback: function () {
      }
    });

  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }

}



// WEBPACK FOOTER //
// ./src/app/public/public.component.ts